import React, { useState, useEffect } from 'react';
import '../../styles/Footer.css';

const HowToFoxPopup = ({ onClose, onLetsCollage }) => (
  <div className="howtofox-overlay" onClick={onClose}>
    <div className="howtofox-popup" onClick={(e) => e.stopPropagation()}>
      <button className="howtofox-close" onClick={onClose}>×</button>
      <h2 className="howtofox-title">How to Fox</h2>
      <ol className="howtofox-list">
        <li>Make a collage</li>
        <li>Post a collage</li>
        <li>Get friend or romantic match referrals from people who vibe with your collage</li>
      </ol>
      <p className="howtofox-note">Verified school email required to post and privacy is protected by anonymizing your profile photo.</p>
      <div className="howtofox-buttons">
        <button className="howtofox-cta" onClick={onLetsCollage}>Let's collage</button>
        <button className="howtofox-cta howtofox-cta--match" onClick={() => {
          onClose();
          const el = document.getElementById('earn-foxes');
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }}>MATCH TO GET $100 DINNER</button>
      </div>
    </div>
  </div>
);

const Footer = ({ onShowSignUp, onSignOut, currentUser, onStartCollage, isPrelaunch = false, onEmailSubmitted }) => {
  const [showHowTo, setShowHowTo] = useState(false);
  /** Main app: visible only while `#homepage-faq-legal` (contact | instagram | legal) intersects the viewport — hides again when scrolled up/out of view. Prelaunch: always visible. */
  const [footerVisible, setFooterVisible] = useState(isPrelaunch);

  useEffect(() => {
    if (isPrelaunch) {
      setFooterVisible(true);
      return undefined;
    }

    const el = document.getElementById('homepage-faq-legal');
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setFooterVisible(Boolean(entry?.isIntersecting));
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: '0px',
      },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [isPrelaunch]);

  useEffect(() => {
    const handleOpenHowToFox = () => setShowHowTo(true);
    window.addEventListener('open-howtofox', handleOpenHowToFox);
    return () => window.removeEventListener('open-howtofox', handleOpenHowToFox);
  }, []);

  return (
    <>
      <footer className={`footer${footerVisible ? ' footer--visible' : ''}`}>
        <div className="footer-content">
          <span className="footer-location">SF & Berkeley, CA</span>
          <div className="footer-copy">
            <span className="footer-copy-line">© 2026 luv.wtf</span>
          </div>
        </div>
      </footer>

      {showHowTo && (
        <HowToFoxPopup
          onClose={() => setShowHowTo(false)}
          onLetsCollage={(e) => {
            setShowHowTo(false);
            if (onStartCollage) onStartCollage(e ?? { preventDefault: () => {} });
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        />
      )}
    </>
  );
};

export default Footer;
